import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";

export class AddressModel {
  constructor(
    public address: string = "",
    public postcode: string = "",
    public city: string = "",
    public country: string = "BE"
  ){
  }

    getCountry(){
      const countries:{[key:string] : string} = {
        BE:'België',
        NL:'Nederland',
        FR:'Frankrijk',
        DE:'Duitsland',
      }
      return this.country?countries[this.country]??this.country:"";
    }
}



@Injectable({
  providedIn: 'root'
})

export class AddressAdapter implements Adapter<AddressModel> {
  constructor() {
  }

  adapt(item: any): AddressModel {
    return new AddressModel(
      item.address,
      item.postcode,
      item.city,
      item.country
    );
  }
}